import { RhSelectFormik } from "@rhythm-ui/react";
import React from "react";

import api from "@/services/api";

const CompanySelectFormik = ({
  name,
  showOnlyClients,
  className,
  isDisabled,
}: {
  name: string;
  showOnlyClients?: boolean;
  className?: string;
  isDisabled?: boolean;
}) => {
  const debounce = (func: (...args: any[]) => Promise<any>, wait: number) => {
    let timeout: ReturnType<typeof setInterval> | undefined;
    return function executedFunction(...args: any[]) {
      const later = () => {
        timeout = undefined;
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const loadOptions = debounce((input: string, callback) => {
    return api.company
      .getCompanies({
        search: input,
        ...(showOnlyClients && { is_client: true }),
      })
      .then((data) => callback(data.data.results));
  }, 700);

  return (
    <RhSelectFormik
      instanceId={name.toString()} //https://github.com/JedWatson/react-select/issues/2629
      isClearable={false}
      name={name}
      placeholder="Search company"
      backspaceRemovesValue={false}
      getOptionLabel={(data: any) => data?.name}
      getOptionValue={(data: any) => data?.id}
      async
      loadOptions={loadOptions}
      cacheOptions
      defaultOptions={true}
      className={className}
      isDisabled={isDisabled}
    />
  );
};

export default CompanySelectFormik;
